import { useState, useEffect, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Responsive: keep each placement's standard aspect ratio and scale to the
// available width. object-contain guarantees the whole creative is visible
// (never cropped) on narrow mobile screens.
const PLACEMENT_STYLES = {
  leaderboard: "w-full max-w-[728px] aspect-[728/90] mx-auto",
  sidebar: "w-full max-w-[300px] aspect-[300/250] mx-auto",
  in_feed: "w-full max-w-[728px] aspect-[728/90] mx-auto",
  footer: "w-full max-w-[728px] aspect-[728/90] mx-auto",
  homepage_hero: "w-full max-w-[970px] aspect-[970/250] mx-auto",
};

export default function AdBanner({ placement, category, className = "" }) {
  const [ad, setAd] = useState(null);

  const loadAd = useCallback(async () => {
    try {
      const params = new URLSearchParams({ placement });
      if (category) params.set("category", category);
      const res = await axios.get(`${API}/ads/serve?${params.toString()}`);
      const ads = res.data;
      if (ads.length > 0) {
        // Pick randomly from top-priority ads
        const maxP = Math.max(...ads.map(a => a.priority));
        const top = ads.filter(a => a.priority === maxP);
        const picked = top[Math.floor(Math.random() * top.length)];
        setAd(picked);
        // Track impression
        axios.post(`${API}/ads/${picked.ad_id}/impression`).catch(() => {});
      }
    } catch {
      // No ads available
    }
  }, [placement, category]);

  useEffect(() => {
    loadAd();
  }, [loadAd]);

  if (!ad) return null;

  const handleClick = () => {
    axios.post(`${API}/ads/${ad.ad_id}/click`).catch(() => {});
  };

  const style = PLACEMENT_STYLES[placement] || "";

  return (
    <div className={`${className}`} data-testid={`ad-${placement}`}>
      <a
        href={ad.click_url || "#"}
        target={ad.click_url ? "_blank" : "_self"}
        rel="noopener noreferrer"
        onClick={handleClick}
        className={`block ${style} overflow-hidden rounded-sm bg-slate-50`}
      >
        <img
          src={ad.image_url}
          alt={ad.name}
          className="w-full h-full object-contain"
          loading="lazy"
        />
      </a>
    </div>
  );
}
